{
  "nl": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Details bewerken",
          "reminder": "Herinneringen bewerken"
        },
        "closeAllRows": "Sluit alle rijen",
        "deleteCount": "Je staat op het punt om {count} betaalschijf te verwijderen. Weet je het zeker? | Je staat op het punt {count} betaalschijven te verwijderen. Weet je het zeker?",
        "delete_installments": "Betalingsschijf verwijderen | Verwijder Betalingsschijven",
        "edit": "Bewerken",
        "newInstallment": "Nieuwe betalingsschijf",
        "openAllRows": "Open alle rijen",
        "publish": "Publiceer",
        "publishCustomer": "Publiceer...",
        "save": "Opslaan",
        "unpublish": "Depubliceer",
        "updateStatus": "Pas status aan",
        "uploadInvoice": "Upload factuur"
      },
      "attributes": {
        "amount": "Bedrag",
        "customer": "Klant",
        "description": "Omschrijving",
        "due_date": "Deadline",
        "group_name": "Betalingsschijf",
        "paid_at": "Betaald op",
        "status_deadline": "Status",
        "unit": "Unit"
      },
      "edit_actions": {
        "edit_amount": "bedragen",
        "edit_deadline": "Deadline",
        "edit_description": "Omschrijving",
        "edit_status": "Status"
      },
      "labels": {
        "cantEditFractions": "Stel de betaalstatus in op 'In wacht' om de regels te bewerken.",
        "changeStatusRequested": "Wijzig betalingsschijven van status 'Verwacht' naar 'Gefactureerd'",
        "changeVisibility": "Verander zichtbaarheid",
        "change_amounts": "Wijzig bedragen",
        "clear_due_date": "Verwijder de deadline voor alle geselecteerde betaalschijven",
        "clear_paid_at": "Verwijder betaaldatum voor alle geselecteerde betaalschijven",
        "countEdit": "Bewerk betalingsschijf voor 1 unit | Bewerk betalingsschijf voor {count} units",
        "created_at": "Aangemaakt op {created_at}",
        "deleteExplanation": "Alle betalingsschijven en facturen worden definitief van het platform verwijderd.",
        "deleteExplanationGroup": "Omdat je alle betaalschijven in deze groep wilt verwijderen, zal de groep ook verwijderd worden.",
        "details": "Details",
        "edit": "Betalingsschijven bewerken",
        "editDueDate": "Bewerk deadline",
        "editInstallmentTerm": "Bewerk betalingsschijf",
        "excl_vat": "excl. btw",
        "giveNewAmount": "Geef een nieuw bedrag",
        "goToUnitInstallments": "Ga naar unitbetalingsschijven",
        "installmentNoteExplainer": "Deze notitie is alleen zichtbaar voor teamleden.",
        "installment_categories": "Aangepaste categorieën",
        "invoices": "1 factuur | {count} facturen",
        "new_installment_fraction_category": "Categorie",
        "noDeadline": "Geen deadline",
        "notPublished": "Niet gepubliceerd",
        "paid": "Betaald",
        "published": "Gepubliceerd",
        "publishedCustomer": "Gepubliceerd voor klant",
        "publishingForCustomers": "Ben je zeker?",
        "selectOne": "Selecteer minstens 1 betalingsschijf",
        "selected": "{selected} betalingsschijf geselecteerd. | {selected} betalingsschijven geselecteerd.",
        "setDueDate": "Geef een deadline",
        "statusExplained": "Wat wil elke afbetalingsstatus betekenen?",
        "status_click_to_change": "Klik om te wijzigen",
        "status_deadline": "Status",
        "statuses": {
          "draft": "In wacht",
          "expected": "Verwacht",
          "overdue": "Achterstallig",
          "paid": "Betaald",
          "requested": "Gefactureerd"
        },
        "toBePaid": "Nog te betalen",
        "total": "Totaal",
        "unitInstallmentsWillBeShownHere": "Betalingsschijven zullen hier getoond worden",
        "unpublishingForCustomers": "Depubliceer alle betaalschrijven voor alle geselecteerde units. Ben je zeker?",
        "updateStatusCount": "Pas betalingsstatus aan voor 1 betalingsschijf | Pas betalingsstatus aan voor {count} betalingsschijven",
        "uploadInvoiceCount": "Upload factuur voor 1 betalingsschijf | Upload factuur voor {count} betalingsschijven",
        "uploadInvoiceUnit": "Factuur uploaden naar {unit_name}",
        "vat": "BTW",
        "vat_with_percentage": "{percentage}% BTW",
        "view_list": "Lijst"
      },
      "legend": {
        "installmentDraft": "Betalingsschijf verwacht",
        "installmentDraftAfterDueDate": "Betalingsschijf verwacht",
        "installmentExpired": "Deadline verstreken",
        "installmentPaid": "Betalingsschijf betaald",
        "installmentPaidAfterDue": "Betalingsschijf betaald na deadline",
        "installmentRequested": "Gefactureerd",
        "reminders": {
          "active": "Er is minstens 1 herinnering ingesteld",
          "none": "Er zijn geen herinneringen ingesteld"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Alle documenten gerelateerd aan betalingsschijven komen hier.",
            "title": "Nog geen documenten!"
          },
          "new": {
            "subtitle": "Nieuwe betalingsschijven komen er binnenkort!"
          }
        }
      },
      "sort_options": {
        "due_date": "Deadline",
        "due_date asc": "Dichtstbijzijnde deadline eerst",
        "due_date desc": "Verste deadline eerst",
        "group_name": "Naam",
        "group_name asc": "Naam A-Z",
        "group_name desc": "Naam Z-A",
        "status": "Status",
        "status asc": "Status A-Z",
        "status desc": "Status Z-A",
        "updated_at asc": "Minst recent bijgewerkt",
        "updated_at desc": "Recent bijgewerkt"
      },
      "validation": {
        "needNumber": "Moet een nummer zijn (bv. 8400.5)"
      }
    }
  }
}
